import styled from 'styled-components';

export const GoSafeInfoLoaderWrapDiv = styled.div(
  props => `
    display:flex;
    width:100%;
    background-color:${props.theme.colors.white.base};
    border-radius:${props.theme.misc.borderRadius.xxlarge};
    padding:${props.theme.spacing.base};

  `,
);

export const GoSafeInfoImgLoader = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.base};
    width: 4rem;
    height:4rem;
  `,
);

export const GoSafeInfoContextWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    padding-left: ${props.theme.spacing.base};
    width: 100%;
  `,
);

export const GoSafeInfoSmallTextLoader = styled.div(
  props => `
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.base};
    width: 25%;
    height:1.3rem;
    margin-bottom :${props.theme.spacing.base};
  
  `,
);

export const GoSafeInfoLargeTextLoader = styled.div(
  props => `
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.base};
    width: 70%;
    height:1.3rem;
  
  `,
);
